import { Controller } from "@hotwired/stimulus"

// Phase 2.7 Tier 3 — copy iCal subscribe URL to clipboard.
// Used on:
//   - meetings/show.html.erb (per-meeting iCal)
//   - meeting_series/show.html.erb (per-series iCal)
//
// The HTML markup wraps a readonly <input> with the URL plus a copy
// button. We support both `navigator.clipboard.writeText` (modern
// secure contexts) and the document.execCommand fallback for older
// browsers / non-HTTPS dev origins.
export default class extends Controller {
  static targets = ["url", "copyButton", "label"]

  copy() {
    const input = this.urlTarget
    if (!input) return
    const text = input.value

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => this._flashCopied())
        .catch(() => this._fallbackSelect(input))
    } else {
      this._fallbackSelect(input)
    }
  }

  _fallbackSelect(input) {
    try {
      input.removeAttribute("readonly")
      input.select()
      input.setSelectionRange(0, input.value.length)
      const ok = document.execCommand("copy")
      input.setAttribute("readonly", "true")
      if (ok) this._flashCopied()
    } catch (_e) {
      // Last-ditch — leave the input selected so the user can Cmd+C manually.
    }
  }

  _flashCopied() {
    if (!this.hasLabelTarget) return
    const original = this.labelTarget.textContent
    this.labelTarget.textContent = "Copied ✓"
    setTimeout(() => { this.labelTarget.textContent = original }, 1400)
  }
}
